export type Env = {
  appId: string;
  gameId: string;
  version: string;
  isDev: boolean;
};

export enum GameId {
  Production = 'solitaire-garden',
}

const envByName: { [key: string]: Env } = {
  production: {
    appId: '279689396297126',
    gameId: GameId.Production,
    version: process.env.VERSION ?? '',
    isDev: false,
  },

  development: {
    appId: '279689396297126',
    gameId: GameId.Production,
    version: process.env.VERSION ?? '',
    isDev: true,
  },
};

export function getEnv(): Env {
  return envByName[process.env.APP_ENV as string] || envByName.production;
}
